import React from 'react';
import Header from '../Header/Header';

const Blog = () => {
    return (

        <>
        <Header></Header>
        <div>
            <h1 className=" text-center ">comming soon</h1>
        </div>
        </>
    );
};

export default Blog;